module.exports = __webpack_public_path__ + "img/20200515_160248.efa752e6.jpg";